<div class="p-dialog-content">
  {{ message }}
</div>
<div class="p-dialog-footer">
  <button pButton (click)="onClick(true)" class="btnPrimary">
    {{ "buttons.dialog.confirm.btnYes" | transloco }}
  </button>
  <button pButton (click)="onClick(false)" class="btnSecoundary">
    {{ "buttons.dialog.confirm.btnNo" | transloco }}
  </button>
</div>
